import { useParams } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Container,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Button,
} from '@material-ui/core';

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ImageGallery from "../Component/ImageGallery";
import VideoPlayer from "../Component/VideoPlayer";
import StopIcon from '@material-ui/icons/Stop';
import SendIcon from '@material-ui/icons/Send';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { teal, indigo } from '@material-ui/core/colors';
import { Height } from "@material-ui/icons";
// import { createTheme } from '@material-ui/core/styles';
// import { ThemeProvider } from '@material-ui/styles';
// const theme = createTheme({
//     palette: {
//         primary: teal,
//         secondary: indigo,
//     },
// });

import releaseNoteAll from './releaseNotesData';

const ReleaseNote = () => {
    const { version } = useParams();
    const [releaseNote, setReleaseNote] = useState(releaseNoteAll);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(0);
    const notesPerPage = 1;
    const totalPages = Math.ceil(releaseNote.length / notesPerPage);

    useEffect(() => {
        let filteredReleaseNote = releaseNoteAll.filter((obj) => obj.version === version) ?? null;
        if (version === "all") filteredReleaseNote = releaseNoteAll;
        else if (version === "latest") filteredReleaseNote = releaseNoteAll.filter((obj) => obj.version === releaseNoteAll[0].version);

        setReleaseNote(filteredReleaseNote?.length === 0 ? releaseNoteAll : filteredReleaseNote);
        setCurrentPage(0); // reset to first page when version changes
    }, [version]);

    const handleNext = () => {
        if (currentPage < totalPages - 1) setCurrentPage(currentPage + 1);
    };

    const handlePrev = () => {
        if (currentPage > 0) setCurrentPage(currentPage - 1);
    };

    const paginatedNotes = releaseNote.slice(
        currentPage * notesPerPage,
        (currentPage + 1) * notesPerPage
    );

    const convertDateFormatThai = (dateString) => {
        const thaiMonths = [
            "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
            "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
        ];

        const [year, month, day] = dateString.split('-');
        const buddhistYear = parseInt(year, 10) + 543;
        const monthName = thaiMonths[parseInt(month, 10) - 1];
        const paddedDay = day.padStart(2, '0');

        return `${paddedDay} ${monthName} ${buddhistYear}`;
    }

    return (
        <div style={{padding: '10px'}}>
            <Container 
                maxWidth="md" 
                style={{
                    padding: '20px',
                    backgroundColor: 'rgb(0 0 0 / 40%)',
                    color: 'white',
                    borderRadius: '10px'
                }}
            >
                <Box display={releaseNote?.length === 1 ? "none" : "flex"} 
                    justifyContent="right" 
                    alignItems="center" 
                    gap="20px" 
                    marginTop="20px"
                >
                    <ArrowBackIosIcon 
                        onClick={handlePrev} 
                        style={{
                            cursor: currentPage === 0 ? "not-allowed" : "pointer",
                            opacity: currentPage === 0 ? 0.3 : 1
                        }}
                    />
                    <Typography variant="body2" style={{ color: 'white' }}>
                        {currentPage + 1} / {totalPages}
                    </Typography>
                    <ArrowForwardIosIcon 
                        onClick={handleNext} 
                        style={{
                            cursor: currentPage >= totalPages - 1 ? "not-allowed" : "pointer",
                            opacity: currentPage >= totalPages - 1 ? 0.3 : 1
                        }}
                    />
                </Box>
                {paginatedNotes.map((obj, index) => (
                    // <div key={index} style={{display: (new Date(obj.date) - new Date()) > 0 ? "none" : "block"}}>
                    <div key={index}>
                        <Typography className="change-log-text" variant="subtitle1">
                            เวอร์ชัน: {obj.version}
                            {
                                (Math.ceil(Math.abs(new Date(obj.date) - new Date()) / (1000 * 60 * 60 * 24)) < 7) ?
                                <div className="badge pulsate">new</div> : ''
                            }
                        </Typography>
                        <Typography className="change-log-text" variant="subtitle1">วันที่: {convertDateFormatThai(obj.date)}</Typography>
                        <Typography className="change-log-text" variant="body1">มีอะไรใหม่:</Typography>
                        <List dense>
                            {
                                obj.changes.map((item, index) => {
                                    let type = typeof item;
                                    return (
                                        (type === "string") ? 
                                            <ListItem key={index} style={{padding: "0px", marginBottom: "10px", alignItems: "flex-start"}}>
                                                <ListItemIcon style={{minWidth: "30px", marginTop: "3px"}}>
                                                    <SendIcon style={{color:"white"}} fontSize='small'/>
                                                </ListItemIcon>
                                                <ListItemText className="change-log-text" key={index}>
                                                    {item}
                                                </ListItemText>
                                            </ListItem>
                                        : item?.type === "image" ?
                                            <ListItem key={index} style={{padding: "0px 0px 0px 20px", margin: "20px 0"}}>
                                                <ImageGallery images={[item.source + `?${obj.version?.replaceAll(".", "")}`]} columns={1}/>
                                            </ListItem>
                                        : item?.type === "gallery" ?
                                            <ListItem key={index} style={{padding: "0px 0px 0px 20px", marginBottom: "10px"}}>
                                                <ImageGallery images={
                                                    item.images.map(img => {
                                                        console.log('img', {...img, img: img.img + `?${obj.version?.replaceAll(".", "")}`})
                                                        return {...img, img: img.img + `?${obj.version?.replaceAll(".", "")}`}
                                                    })
                                                    } columns={item.columns ?? 3} height={item.height ?? 220}/>
                                            </ListItem>
                                        : item?.type === "subContent" ?
                                            <ListItem key={index} style={{padding: "0px", margin: "0px"}}>
                                                <List dense style={{padding: "0px", margin: "0px"}}>
                                                    {
                                                        item?.content.map((subItem, subIndex) => {
                                                            if (typeof subItem === "object") {
                                                                return (
                                                                    <ListItem key={subIndex} style={{padding: "0px 0px 0px 40px", marginBottom: "10px", alignItems: "flex-start"}}>
                                                                        <List dense style={{padding: "0px", margin: "0px"}}>
                                                                            {
                                                                                subItem?.map((subSubItem, subSubIndex) => {
                                                                                    if (typeof subSubItem === "object") {
                                                                                        return (
                                                                                            <ListItem key={subSubIndex} style={{padding: "0px 0px 0px 20px", marginBottom: "10px", alignItems: "flex-start"}}>
                                                                                                <List dense style={{padding: "0px", margin: "0px"}}>
                                                                                                    {
                                                                                                        subSubItem?.map((subSubSubItem, subSubSubIndex) => {
                                                                                                            return (
                                                                                                                <ListItem key={subSubSubIndex} style={{padding: "0px", marginBottom: "10px", alignItems: "flex-start"}}>
                                                                                                                    <ListItemIcon style={{minWidth: "30px", marginTop: "3px"}}>
                                                                                                                        <ArrowRightIcon style={{color:"white"}} fontSize='small'/>
                                                                                                                    </ListItemIcon>
                                                                                                                    <ListItemText className="change-log-text" key={subSubSubIndex}>
                                                                                                                        {subSubSubItem}
                                                                                                                    </ListItemText>
                                                                                                                </ListItem>
                                                                                                            )
                                                                                                        })
                                                                                                    }
                                                                                                </List>
                                                                                            </ListItem>
                                                                                        )
                                                                                    } else {
                                                                                        return (
                                                                                            <ListItem key={subSubIndex} style={{padding: "0px", marginBottom: "10px", alignItems: "flex-start"}}>
                                                                                                <ListItemIcon style={{minWidth: "30px", marginTop: "3px"}}>
                                                                                                    <ArrowRightIcon style={{color:"white"}} fontSize='small'/>
                                                                                                </ListItemIcon>
                                                                                                <ListItemText className="change-log-text" key={subSubIndex}>
                                                                                                    {subSubItem}
                                                                                                </ListItemText>
                                                                                            </ListItem>
                                                                                        )
                                                                                    }
                                                                                })
                                                                            }
                                                                        </List>
                                                                    </ListItem>
                                                                )
                                                            } else {
                                                                return (
                                                                    <ListItem key={subIndex} style={{padding: "0px 0px 0px 20px", marginBottom: "10px", alignItems: "flex-start"}}>
                                                                        <ListItemIcon style={{minWidth: "30px", marginTop: "3px"}}>
                                                                            <StopIcon style={{color:"white"}} fontSize='small'/>
                                                                        </ListItemIcon>
                                                                        <ListItemText className="change-log-text" key={subIndex}>
                                                                            {subItem}
                                                                        </ListItemText>
                                                                    </ListItem>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </List>
                                            </ListItem>
                                        : item?.type === "video" ?
                                            <ListItem key={index} style={{padding: "0px 0px 0px 20px", marginBottom: "10px"}}>
                                                <VideoPlayer 
                                                    src={item.source}
                                                    autoPlay={false}
                                                    muted={false}
                                                    controls={true}
                                                />
                                            </ListItem>
                                        : ""
                                    )
                                })
                            }
                        </List>
                        <Divider className="hrFade" style={{marginTop: '20px', marginBottom: '20px'}}/>
                    </div>
                ))}
                <Box display={releaseNote?.length === 1 ? "flex" : "none"} 
                    justifyContent="center" 
                    alignItems="center" 
                    gap="20px" 
                    marginTop="20px"
                >
                    <Button
                        // variant="outlined" 
                        variant="contained" 
                        color="primary" 
                        onClick={() => window.location.href = "/release/all"}
                    >
                        ดูเวอร์ชันทั้งหมด
                    </Button>
                </Box>
            </Container>
        </div>
    );
}

export default ReleaseNote;
